import { AnchorHTMLAttributes, useContext } from 'react';
import { TenantContext } from '../../context/tenant-context';
import classNames from 'classnames';

export const LegacyDownloadLink = (props: AnchorHTMLAttributes<HTMLAnchorElement>) => {
  const { contextPath } = useContext(TenantContext);

  const contextPathUrl = contextPath && !contextPath.includes('legacy-app') ? contextPath : '/';
  const href = `${contextPathUrl}legacy-app/manager/${props.href}`;

  return <a {...props} className={classNames('cursor-pointer', props.className)} href={href} />;
};
